import { SurfaceType } from '@jms/model';
import type { SurfaceTypeDefinition } from '../../core/runtime/surfaces/surface.definition';
import { SURFACE_SCHEMA_SLOTS } from '../../core/runtime/surfaces/surface.schema.slots';

export const detailSurface = {
  id: SurfaceType.Detail,
  saveStrategy: 'patch',
  defaultFieldMode: 'edit',
  viewStatePersistence: 'session',
  sectionLayout: { columns: 1, maxWidth: 800, sectionBorder: false, columnDivider: true },
  slots: SURFACE_SCHEMA_SLOTS[SurfaceType.Detail],
} as const satisfies SurfaceTypeDefinition<SurfaceType.Detail>;
